import React from "react";

import styled from "styled-components";

//assets

//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";

const BodyP = styled.p`
  font-size: ${typographySizes.text.body.size.desktop}rem;
  line-height: ${typographySizes.text.body.lineHeight};
  color: ${({ color }) => color};
  text-shadow: 0px 0px ${distances.shadowSmall}rem ${({ color }) => color};
  @media (max-width: ${mediaQuery.tablet}) {
    font-size: ${typographySizes.text.body.size.mobile}rem;
  }
`;

const Body = ({ children, className, color }) => {
  return (
    <BodyP className={className} color={color}>
      <TextWithLineBreaks text={children} />
    </BodyP>
  );
};

export default Body;
